import { buildDiagnosisResult } from './builders';
import type { DiagnosisResultContent } from './types';

/** SRCE（自由放浪遊牧民） */
const srceContent: DiagnosisResultContent = {
  code: 'SRCE',
  name: '自由放浪遊牧民',
  catchphrase: '全てはその場のノリ次第。究極の自由人',
  rarity: 3,
  style:
    '「縛られず、風の向くまま」を貫く放浪派。計画は持たず、その日の気分と直感で旅を進める。定番にもこだわらず、面白そうな場所・人・体験に自然と引き寄せられる。安定を求めすぎず、多少の不便も旅のスパイスと捉える。ノリと運で世界を渡り歩く、現代の遊牧民タイプ。',
  strengths: [
    { lead: '自由度が最大', text: '予定に縛られず、本当にやりたいことだけを選べる。' },
    { lead: '偶然の出会いが多い', text: 'ノープランゆえ、ガイドにない体験に出会いやすい。' },
    { lead: 'ストレスフリー', text: '「すべきこと」がなく、心が軽い旅ができる。' },
  ],
  weaknesses: [
    { lead: '段取り不足', text: '予約漏れや移動ミスが起きやすい。' },
    { lead: '同行者とズレる', text: 'ペースが読めず、グループ旅では摩擦が出ることも。' },
    { lead: '見逃しが多い', text: '計画がないため、定番スポットを逃しがち。' },
  ],
  aaru: [
    { icon: 'msg', text: '「なんとなくこっち行こう」が口癖' },
    { icon: 'camera', text: '予定は決めず気分で移動' },
    { icon: 'coffee', text: '面白そうな人に話しかける' },
    { icon: 'camera', text: '帰りの予定がいつも曖昧' },
  ],
  manual: {
    good: '気ままさを尊重する／ノリに乗る',
    ng: '「きっちり予定立てて」と縛る',
    tips: '宿と帰りの交通だけ押さえれば自由に動ける',
  },
  compatibility: {
    good: 'SRCZ（マイペース）／SACE（ゆるアクティブ）',
    conflict: 'PACE（完璧弾丸）／PACZ（安心計画）',
    tips: '集合拠点を1つ決めれば自由行動と両立できる',
  },
  destinations: {
    domestic: '沖縄本島（気ままなドライブ）／瀬戸内（島から島へ自由に）',
    overseas: 'タイ（ノリで楽しめる）／ポルトガル（放浪に最適な街歩き）',
  },
};

export const srceDiagnosisResult = buildDiagnosisResult(srceContent);
